// Reconciliation

export const GET_TRANSACTION_RECONCILIATION = "GET_TRANSACTION_RECONCILIATION"
export const SET_TRANSACTION_RECONCILIATION = "SET_TRANSACTION_RECONCILIATION"

// Date

export const SET_TRANSITION_DATE = "SET_TRANSITION_DATE"

// Loader

export const SET_TRANSACTION_RECONCILIATION_LOADER = "SET_TRANSACTION_RECONCILIATION_LOADER";

// TESTED
export const GET_TRANSACTION_CHART = "GET_TRANSACTION_CHART";
export const SET_TRANSACTION_CHART = "SET_TRANSACTION_CHART"